module.exports = __webpack_public_path__ + "static/media/web-dev-best-in-frontend-and-backend.b1f5e42a.jpg";